import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../contexts/AuthContext";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import usePricingAccess from "../../hooks/usePricingAccess";
import SalvageDashboard from "../../components/leads/salvage/SalvageDashboard";
import SalvageTable from "../../components/leads/salvage/SalvageTable";
import { SalvageStage, useSalvageSummary } from "../../data/useSalvage";
import { wilmaSAVCustomerId } from "../../config";

export default function Salvage() {
  const { t } = useTranslation("leads");
  const { setInfo } = usePageNameContext();
  const { customerId } = useAuth();
  const { canViewPrices } = usePricingAccess();
  const isSavCustomer = !!customerId && customerId === wilmaSAVCustomerId;
  const { summary } = useSalvageSummary(isSavCustomer ? customerId : undefined, "Salvage");
  const [stage, setStage] = useState<SalvageStage | undefined>();

  useEffect(() => {
    setInfo({ name: t("Salvage"), desc: t("Vehicles bought to send to Copart") });
  }, [setInfo, t]);

  if (!isSavCustomer || !customerId) {
    return <p className="mt-4 text-sm text-gray-600">{t("Salvage is only available on SAV.")}</p>;
  }

  return (
    <div className="mt-4 space-y-4">
      <SalvageDashboard
        summary={summary.data?.data}
        loading={summary.isLoading}
        canViewPrices={canViewPrices}
        stage={stage}
        onStageChange={setStage}
      />
      <SalvageTable customerId={customerId} canViewPrices={canViewPrices} stage={stage} />
    </div>
  );
}
